import React, { Component } from 'react';
import Routes from './routes';
import DocumentTitle from 'react-document-title';
import SiderCustom from './components/SiderCustom';
import HeaderCustom from './components/HeaderCustom';
import { withRouter } from 'react-router-dom';
import { Layout, message} from 'antd';
import { connectAlita } from 'redux-alita';
import { getPermissions, getSiteRoleAdminRoles } from '../src/axios/index';
import { LocaleProvider } from 'antd';
import ShowSkeleton from './components/pages/ShowSkeleton';
import enUS from 'antd/lib/locale-provider/en_US';
import moment from 'moment/moment.js';
import routesConfig from './routes/config';
import 'moment/locale/zh-cn';
import 'moment/locale/ko';
import { withTranslation } from "react-i18next";
moment.locale('en');

const { Content } = Layout;

@withTranslation(['common'])
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            title: '',
            loginsuccess: false,
            keyfileSuccess: false,// Both loginsuccess and keyfileSuccess must be true to enter the menu
            locale: enUS,
            al: 'en-US',
            type: '',
            allowedCodes: [],
            loading: true,
        }
    }

    componentWillMount() {
        this.getServerConfig();
        this.getPermissionsList();
    // this.navLang()
    }

    componentWillUnmount() {
        this.setState = (state, callback) => { return; };
    }

    componentWillReceiveProps(nextprops) {
        moment.locale('en');
    }


    getServerConfig = () => {
        const { setAlitaState } = this.props;
        setAlitaState({
            stateName: 'serverConfig',
            funcName: 'getServerConfig',
        }).then(res => {
            console.info("serverConfig :", res.data.data)
            localStorage.setItem('serverConfig', JSON.stringify(res.data.data))
            this.setState({
                type: res.data.data.deploymentMode
            })
        });
    };


    getPermissionsList = () => {
        const userDataString = localStorage.getItem('user')
        if (userDataString) {
            const user = JSON.parse(userDataString).data;
            getPermissions({ id: user.id }).then(res => {
                if (res.code === 100000) {
                    getSiteRoleAdminRoles({ id: user.id, params: { page: 1, per_page: 10 } }).then(roleRes => {
                        let allowedCodes = [];
                        if (roleRes.code === 100000) {
                            const permissionData = res.data.permissions.menu;
                            const curPath = this.props.history.location.pathname;
                            if (permissionData && Array.isArray(permissionData)) {
                                if (permissionData.length === 0) {
                                    if (roleRes.data.roles.some(item => item.role_id === 1)) {
                                        allowedCodes = null;
                                        // If the current path is root, redirect to the specified route; otherwise, keep the current path
                                        this.props.history.replace(curPath === '/load' ? '/updatelog' : curPath);
                                    } else {
                                        message.warning(this.props.t('PermissionForThis'))
                                        this.props.history.replace('/');
                                    }
                                } else {
                                    allowedCodes = permissionData.map(item => item.code);
                                    let matchedPath = '';
                                    const findRoutePath = (menus, code) => {
                                        for (let i = 0; i < menus.length; i++) {
                                            const menu = menus[i];
                                            if (menu.code === code) {
                                                // If the menu has subs, return the first sub key matching code in menuList
                                                if (menu.subs && menu.subs.length > 0) {
                                                    // menuList may contain multiple codes, prefer sub matching code in menuList
                                                    const subCode = permissionData.find(m => menu.subs.some(sub => sub.code === m.code));
                                                    if (subCode) {
                                                        const subMenu = menu.subs.find(sub => sub.code === subCode.code);
                                                        if (subMenu) return subMenu.key;
                                                    }
                                                    // If not found, return the first sub key
                                                    return menu.subs[0].key;
                                                }
                                                return menu.route || menu.key || '';
                                            }
                                            if (menu.subs) {
                                                const subPath = findRoutePath(menu.subs, code);
                                                if (subPath) return subPath;
                                            }
                                        }
                                        return '';
                                    };
                                    matchedPath = findRoutePath(routesConfig.menus, permissionData[0].code);
                                    if (matchedPath) {
                                        this.props.history.replace(curPath === '/load' ? matchedPath : curPath);
                                    } else {
                                        this.props.history.replace('/');
                                    }
                                }
                            } else {
                                allowedCodes = null;
                                message.warning(this.props.t('PermissionForThis'))
                                this.props.history.replace('/');
                            }
                        } else {
                            allowedCodes = null;
                            message.warning(this.props.t('PermissionForThis'))
                            this.props.history.replace('/');
                        }
                        this.setState({ allowedCodes: allowedCodes, loading: false });
                    })

                } else {
                    this.setState({ allowedCodes: [], loading: false });
                    message.warning(this.props.t('PermissionForThis'))
                    this.props.history.replace('/');
                }
            });
        } else {
            message.warning(this.props.t('PermissionForThis'))
            this.props.history.replace('/');
        }
    }



    getClientWidth = () => { // Get current browser width and set responsive state
        const { setAlitaState } = this.props;
        const clientWidth = window.innerWidth;
        setAlitaState({ stateName: 'clientWidth', data: window.innerWidth });
        setAlitaState({ stateName: 'clientHeight', data: window.innerHeight });
    // setAlitaState({ stateName: 'responsive', data: { isMobile: clientWidth <= 992 } });
        if (clientWidth <= 900) {
            this.setState({
                collapsed: true,
            });
        } else {
            this.setState({
                collapsed: false,
            });
        }
    };

    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };


    render() {
        const { title, locale, allowedCodes, loading } = this.state;
        const { auth = { data: {} }, responsive = { data: {} } } = this.props;
        if (loading) {
            return <ShowSkeleton />
        }
        if (!allowedCodes || (Array.isArray(allowedCodes) && allowedCodes.length === 0)) {
            console.warn('[App render] allowedCodes is empty, should have all permissions in theory');
        }
        return (
            <LocaleProvider locale={locale}>
                <DocumentTitle title={title}>
                    <Layout>
                        {!responsive.data.isMobile && <SiderCustom collapsed={this.state.collapsed} toggle={this.toggle} allowedCodes={allowedCodes} />}
                        <Layout className={this.state.collapsed ? 'mg-left-80' : 'mg-left-300'}>
                            <HeaderCustom toggle={this.toggle} collapsed={this.state.collapsed} user={auth.data || {}} />
                            <Content style={{ overflow: 'auto', height: '100%', marginTop: '65px' }}>
                                <Routes auth={auth} allowedCodes={allowedCodes} />
                            </Content>
                        </Layout>
                    </Layout>
                </DocumentTitle>
            </LocaleProvider>
        )
    }
}

export default withRouter(connectAlita(['auth', 'responsive', "serverConfig", "licenseMode", 'licenseRestriction', 'userIDMode', 'winAll', 'al'])(App));
